export const AppBenefitNotificationDataHooks = {
  container: 'app-benefit-notification-container',
  description: 'app-benefit-notification-description',
};
